import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule } from '@angular/core';
import { fromEvent, Subject, Observable, ReplaySubject } from 'rxjs';
import { DOCUMENT } from '@angular/common';

/**
 *
 */
class WindowResize {
    constructor(zone) {
        this.zone = zone;
        /**
         * current subscriber count on shared stream, the first subscriber
         * will trigger shared stream registration on window resize stream
         * if all subscribers are removed we automatically remove from
         */
        this.subscriberCount = 0;
        this.windowResize$ = fromEvent(window, 'resize');
        this.shared$ = new Subject();
    }
    /**
     * create shared event stream and register to this
     */
    onChange() {
        // subscribe
        return new Observable(observer => {
            this.subscriberCount++;
            const event$ = this.shared$.subscribe(observer);
            if (this.subscriberCount === 1) {
                this.subscribeToWindowResizeEvent();
            }
            // unsubscribe
            return () => {
                event$.unsubscribe();
                this.subscriberCount--;
                if (this.subscriberCount <= 0) {
                    this.resizeSubscription.unsubscribe();
                }
            };
        });
    }
    /**
     * register to window resize events
     */
    subscribeToWindowResizeEvent() {
        this.zone.runOutsideAngular(() => {
            this.resizeSubscription = this.windowResize$
                .pipe(debounceAnimationFrame$1())
                .subscribe(() => this.shared$.next(null));
        });
    }
}
WindowResize.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: WindowResize, deps: [{ token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Injectable });
WindowResize.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: WindowResize, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: WindowResize, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i0.NgZone }]; } });
function debounceAnimationFrame$1() {
    return (source$) => {
        let resizeFired = false;
        let drawing = false;
        const requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame;
        const obs = new Observable((observer) => {
            function drawResize() {
                if (resizeFired === true) {
                    resizeFired = false;
                    requestAnimationFrame(() => {
                        observer.next();
                        drawResize();
                    });
                }
                else {
                    drawing = false;
                }
            }
            source$.subscribe(() => {
                if (drawing === false) {
                    resizeFired = true;
                    drawResize();
                }
            });
        });
        return obs;
    };
}

/**
 *
 */
class WindowScroll {
    constructor(zone, doc) {
        this.zone = zone;
        this.doc = doc;
        /**
         * current subscriber count on shared stream, the first subscriber
         * will trigger shared stream registration on window resize stream
         * if all subscribers are removed we automatically remove from
         */
        this.subscriberCount = 0;
        this.windowScroll$ = fromEvent(window, 'scroll');
        this.shared$ = new Subject();
    }
    /**
     * create shared event stream and register to this
     */
    onChange() {
        // subscribe
        return new Observable(observer => {
            this.subscriberCount++;
            const event$ = this.shared$.subscribe(observer);
            if (this.subscriberCount === 1) {
                this.subscribeToWindowResizeEvent();
            }
            // unsubscribe
            return () => {
                event$.unsubscribe();
                this.subscriberCount--;
                if (this.subscriberCount <= 0) {
                    this.resizeSubscription.unsubscribe();
                }
            };
        });
    }
    /**
     * register to window resize events
     */
    subscribeToWindowResizeEvent() {
        this.zone.runOutsideAngular(() => {
            this.resizeSubscription = this.windowScroll$
                .pipe(debounceAnimationFrame())
                .subscribe(() => {
                const window = this.doc.defaultView;
                this.shared$.next({ x: window.scrollX, y: window.scrollY
                });
            });
        });
    }
}
WindowScroll.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: WindowScroll, deps: [{ token: i0.NgZone }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
WindowScroll.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: WindowScroll, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: WindowScroll, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () {
        return [{ type: i0.NgZone }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [DOCUMENT]
                    }] }];
    } });
function debounceAnimationFrame() {
    return (source$) => {
        let scrollFired = false;
        let scrolling = false;
        const requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame;
        const obs = new Observable((observer) => {
            function doScroll() {
                if (scrollFired === true) {
                    scrollFired = false;
                    requestAnimationFrame(() => {
                        observer.next();
                        doScroll();
                    });
                }
                else {
                    scrolling = false;
                }
            }
            source$.subscribe(() => {
                if (scrolling === false) {
                    scrollFired = true;
                    doScroll();
                }
            });
        });
        return obs;
    };
}

class AiHubUtilsModule {
}
AiHubUtilsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AiHubUtilsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AiHubUtilsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AiHubUtilsModule });
AiHubUtilsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AiHubUtilsModule, providers: [
        WindowResize,
        WindowScroll
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AiHubUtilsModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        WindowResize,
                        WindowScroll
                    ]
                }]
        }] });

/**
 * AsyncEvent which will emits through EventEmitter
 * so we can do some (async) operations before we
 * let pass / cancel the event.
 */
class AihubAsyncEvent {
    constructor() {
        this.event$ = new ReplaySubject(1);
    }
    /**
     * returns promise which holds current state from event
     * @internal
     */
    get completed() {
        return this.event$.toPromise();
    }
    /**
     * should be called to continue event
     *
     * @example
     *
     * public async onAsyncHook(event: AsyncEvent) {
     *     await this.doAsyncOperation();
     *     event.done();
     * }
     */
    done() {
        this.event$.next(true);
        this.complete();
    }
    /**
     * should be called to continue event
     *
     * @example
     *
     * public async onAsyncHook(event: AsyncEvent) {
     *     try {
     *         await this.doAsyncOperation();
     *         event.done();
     *     } catch (fatalError: Error) {
     *         event.cancel();
     *     }
     * }
     */
    cancel() {
        this.event$.next(false);
        this.complete();
    }
    complete() {
        this.event$.complete();
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { AiHubUtilsModule, AihubAsyncEvent, WindowResize, WindowScroll };
